import { render, staticRenderFns } from "./BlujayGsoftIndex.vue?vue&type=template&id=4c4ef0dd&scoped=true&"
import script from "./BlujayGsoftIndex.vue?vue&type=script&lang=js&"
export * from "./BlujayGsoftIndex.vue?vue&type=script&lang=js&"
import style0 from "./BlujayGsoftIndex.vue?vue&type=style&index=0&id=4c4ef0dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4ef0dd",
  null
  
)

export default component.exports